import React, { useState } from 'react';
import ModalVideo from 'react-modal-video';
import { Link } from 'react-router-dom';

import aboutImg from '../../assets/img/about/about-1.png';
import shapeImg1 from '../../assets/img/about/about-shape-1.png';
import shapeImg2 from '../../assets/img/about/about-shape-2.png';

const About = () => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => setIsOpen(!isOpen);

  return (
    <div className="about__area pb-100 p-relative">
      <ModalVideo
        channel="youtube"
        isOpen={isOpen}
        videoId="PO_fBTkoznc"
        onClose={() => {
          openModal();
        }}
      />
      <div className="about__shape-1 d-none d-md-block">
        <img src={shapeImg1} alt="" />
      </div>
      <div className="about__shape-2 d-none d-xl-block">
        <img src={shapeImg2} alt="" />
      </div>
      <div className="container">
        <div className="row align-items-center">
          <div
            className="col-xl-6 col-lg-6 wow animate__fadeInLeft"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
          >
            <div className="about__img">
              <img src={aboutImg} alt="" />
            </div>
          </div>
          <div
            className="col-xl-6 col-lg-6 wow animate__fadeInRight"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
          >
            <div className="about__section-box pb-10">
              <h4 className="section-subtitle char-anim">About TGVC Technologies</h4>
            </div>
            <div className="about__content">
              <p className="char-anim-2">
                <b>TGVC Technologies</b>, based in <b>Hyderabad</b>, Telangana, India, is a dynamic and future-ready technology company established on <b>4th September 2024</b>. With a mission to build intelligent, scalable, and cross-domain digital solutions, TGVC Technologies is driven by innovation, agility, and a commitment to customer success.{' '}
              </p>
            </div>
            <div className="about-3__content-list about-3__content-list-2">
                    <ul>
                      <li>
                        <i className="fal fa-check-square"></i>
                        <span>
                          We are proud to be a <b>Startup India</b> recognized entity.
                        </span>
                      </li>
                      <li>
                        <i className="fal fa-check-square"></i>
                        <span>Registered as a <b>Micro, Small & Medium Enterprise (MSME)</b>. </span>
                      </li>
                    </ul>
                  </div>
              <div className="about__content">
              <p className="char-anim-2">
                We’re not just another tech company.
                We’re the team that turns coffee into code, ideas into impact, and problems into elegant digital solutions.
                Born from a passion for innovation and a drive to solve real-world challenges, our mission is simple: build smart, human-centered technology that works beautifully.{' '}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
